// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"0639ec0d","146":"91e92381","512":"00ff8f9f","747":"32c97cca","765":"9f34fac9","949":"9f4c8345","969":"34384635","991":"eb857668"}[chunkId] + ".chunk.css";
};